import { API_CALLS } from "@/services/apis/index.js";

export default {
  getAllCurrencyRates() {
    return new Promise((resolve, reject) => {
      API_CALLS.getAllCurrencyRatesAPI()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getBoxLocations() {
    return new Promise((resolve, reject) => {
      API_CALLS.getBoxLocationsAPI()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getColors() {
    return new Promise((resolve, reject) => {
     API_CALLS.getColorsAPI()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
